import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReferenceDataCategoriesConstants, ReferenceDataService } from 'rome-library';
import { TagManagerConstants } from './constants/tag-manager-constants';

export function initGoogleClientIdFromService(referenceDataService: ReferenceDataService): any {
  const clientId = referenceDataService.getConfigurationValueByCode(
    ReferenceDataCategoriesConstants.CLIENT_ENVIRONMENT_CATEGORY,
    TagManagerConstants.GoogleAnalyticsConfigName,
    TagManagerConstants.GoogleAnalyticsConfigIdCode
  );

  return { id: clientId || TagManagerConstants.NoClientId };
}

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: 'googleTagManagerConfig',
      useFactory: initGoogleClientIdFromService,
      deps: [ReferenceDataService]
    }
  ]
})
export class BoiGoogleTagManagerModule {}
